/* eslint-disable no-unused-vars */
import React from 'react' // eslint-disable-line no-unused-vars
import via2 from './assets/VIA2.png'
import via3 from './assets/VIA3.png'
import via5 from './assets/VIA5.png'
// eslint-disable-next-line no-unused-vars
import { Link, Redirect } from 'react-router-dom'
import StaticConfig from '../StaticConfig.js'
import { ANALYTICS_LINK_SECTIONS, PERMISSIONS, PATIENT } from '../../constants'
import { API_BASE_URL } from '../../index'
// eslint-disable-next-line no-unused-vars
import { getPermittedOptions } from './BotAssistantUtils'
import { getCookie } from '../../helpers/CookieHandler'

class Content extends React.Component {
  render () {
    if (this.props.selection && this.props.selection.deadend) {
      return <Deadend content={this.props.content.deadend} permissions={this.props.permissions} />
    }

    if (this.props.selection) {
      if (this.props.selection.content) {
        return <Answer {...this.props} />
      } else if (this.props.selection.name) {
        return <ProductCategories {...this.props} />
      } else if (this.props.selection.id || this.props.selection.categoryId) {
        return <Questions {...this.props} />
      }
    }

    if (
      this.props.selection &&
      this.props.selection.value &&
      this.props.content.link[this.props.selection.value]
    ) {
      return (
        <Answer
          {...this.props}
          selection={{
            content: {
              contentType: 'LINK',
              displayText: this.props.content.link[this.props.selection.value]
            }
          }}
        />
      )
    }

    if (this.props.selection && this.props.selection.value) {
      switch (this.props.selection.value) {
        case this.props.landingSelectionValue:
          return <Landing {...this.props}
            showFeedbackLink={this.props.userType === PATIENT}
          />
        case this.props.content.landing.options[0].value:
          return (
            <StaticSelection
              {...this.props}
              static={this.props.content.static.product}
            />
          )
        case this.props.content.landing.options[1].value:
          return (
            <StaticSelection
              {...this.props}
              static={this.props.content.static.clinical}
              showFeedbackLink={this.props.userType !== PATIENT}
            />
          )
        case this.props.content.landing.options[2].value:
          return (
            <ReportAdverseEvents
              selections={this.props.selections}
              onNav={this.props.onNav}
              promptContent={this.props.content.static}
              languageContent={this.props.patientContent}
            />
          )
        case this.props.content.landing.options[3].value:
          return (
            <AssistantRedirect
              prompt={this.props.content.static.stabilityPrompt}
              pathname={this.props.content.static.stabilityRedirect}
              state={null}
            />
          )
        case this.props.content.landing.options[4].value:
          return (
            <AssistantRedirect
              prompt={this.props.content.static.stabilityPromptPatient}
              pathname={this.props.content.static.stabilityRedirect}
              state={null}
            />
          )
        case this.props.content.landing.options[5].value:
          return (
            <StaticSelection
              {...this.props}
              static={this.props.content.static.disease}
            />
          )
       case this.props.content.landing.options[6].value:
      //  case this.props.content.landing.options[this.props.content.landing.options.landingPos].value:
          return (
            <AssistantRedirect
              prompt={this.props.content.static.mslPrompt}
              pathname={this.props.content.static.mslRedirect}
              state={{
                fields: {
                  question: {
                    value: this.props.content.static.mslRedirectState
                  }
                }
              }}
            />
          )
        case this.props.content.static.product.options[4].value:
        //case this.props.content.static.product.options[this.props.content.static.product.prodspecinfpos].value:
          return <ProductSelection {...this.props} />
        case this.props.content.static.product.options[5].value:
          return (
            <AssistantRedirect
              prompt={this.props.content.static.productPrompt}
              pathname={this.props.content.static.productRedirect}
              state={{}}
            />
          )
        default:
      }
    }

    return <Error content={this.props.content.error} />
  }
}

/* LANDING PAGE */
// eslint-disable-next-line no-unused-vars
function Landing (props) {
  const permittedOptions = getPermittedOptions(props.content.landing.options, props.permissions, props.userType)
  const centerLastOption = (permittedOptions.length % 2) === 1
  const options = permittedOptions.map((option, index, { length }) =>
    <span
      className={centerLastOption && (index === length - 1) ? 'one-col' : 'two-col'}
      key={index}
    >
      <div
        className='assistant-option'
        onClick={() => props.onClick(option)}
        data-tag='track-link'
        data-analytics-text={ANALYTICS_LINK_SECTIONS.ASSISTANT + option.value}
      >
        {option.label}
      </div>
    </span>)
  return (
    <div className='assistant-content'>
      <div className='landing-image'>
        <img src={via3} alt='Ami' />
      </div>

      <div>
        <b>{props.content.landing.confirmation}</b>
        {props.content.landing.intro}
      </div>
      <hr />
      <div className='assistant-prompt'>{props.content.landing.prompt}</div>
      <div className='assistant-options'>{options}</div>
    </div>
  )
}

function AssistantRedirect ({ prompt, pathname, state }) {
  return (
    <div className='assistant-content'>
      <div className='assistant-prompt'>{prompt}</div>
      <Redirect
        to={{
          pathname,
          state
        }}
      />
    </div>
  )
}

function StaticSelection (props) {
  const permittedOptions = getPermittedOptions(props.static.options, props.permissions, props.userType)
  const col = permittedOptions.length > 5 ? 'two-col' : 'one-col'
  const options = permittedOptions.map((option, index) => (
    <span className={col} key={index}>
      <div
        className='assistant-option'
        onClick={() => props.onClick(option)}
        data-tag='track-link'
        data-analytics-text={ANALYTICS_LINK_SECTIONS.ASSISTANT + option.value}
      >
        {option.label}
      </div>
    </span>
  ))
  return (
    <div className='assistant-content'>
      {_createNav(props.selections, props.onNav)}
      <div className='assistant-prompt'>
        <b>{props.static.confirmation}</b> {props.static.prompt}
      </div>
      <div className='assistant-options'>{options}</div>
    </div>
  )
}

/* ADVERSE EVENTS PAGE */
function ReportAdverseEvents ({ selections, onNav, languageContent, promptContent }) {
  return (
    <div className='assistant-content'>
      {_createNav(selections, onNav)}
      <div className='assistant-prompt' style={{ marginBottom: '0.5rem' }}>
        <strong>{promptContent.adverseEventsConfirmation}</strong>
      </div>
      <div style={{ padding: '0 12px' }}>
        {languageContent.reportAnAdverseEventCall}
        {' '}<a style={{ whiteSpace: 'nowrap' }} href='tel:8446633742'>844-663-3742</a>
        {languageContent.FDAContact}
        {' '}<a style={{ whiteSpace: 'nowrap' }} href='tel:+18003321088'>1-800-FDA-1088 <wbr/>(1-800-332-1088)</a>
        .
      </div>
    </div>
  )
}

/* PRODUCT INFORMATION FLOW */
function ProductSelection (props) {
  const products = props.products.map((product, index) => (
    <button
      className='btn btn-info btn-lg m-2'
      onClick={() => props.onClick(product)}
      data-tag='track-link'
      data-analytics-text={ANALYTICS_LINK_SECTIONS.ASSISTANT + product.name}
      key={index}
    >
      {product.name}
    </button>
  ))
  return (
    <div className='assistant-content'>
      {_createNav(props.selections, props.onNav)}
      <div className='assistant-prompt'>
        <b>{props.content.static.productSelection.confirmation}</b>{' '}
        {props.content.static.productSelection.prompt}
      </div>
      <br />
      <div className='assistant-options'>{products}</div>
    </div>
  )
}

function ProductCategories (props) {
  const categories = props.categories.map((category, index) => (
    <span className='two-col' key={index}>
      <div
        className='assistant-option'
        onClick={() => props.onClick(category)}
        data-tag='track-link'
        data-analytics-text={
          ANALYTICS_LINK_SECTIONS.ASSISTANT + category.category
        }
      >
      <CategoryText 
      selectedCategory={category.category}
      categories={props.content.categories}/>
        
      </div>
    </span>
  ))
  return (
    <div className='assistant-content'>
      {_createNav(props.selections, props.onNav)}
      <div className='assistant-prompt'>
        <b>{`${props.content.static.categorySelection.confirmation} ${props.selection.name}!`}</b>{' '}
        {props.content.static.categorySelection.prompt}
      </div>
      <div className='assistant-options'>{categories}</div>
    </div>
  )
}

function Questions (props) {
  const questions = props.questions[props.currentPage].map(
    (question, index) => (
       

      <span className='one-col' key={index}>
        <div
          className='assistant-option question-option'
          data-tag='track-link'
          data-analytics-text={
            ANALYTICS_LINK_SECTIONS.ASSISTANT +
            (question.content
              ? question.content.displayText
              : question.displayText)
          }
          onClick={() => props.onClick(question)}
        >
          <QuestionText {...question}/>
          
        </div>
      </span>
    )
  )
  const displayName = props.selection.category
    ? props.selection.category
    : props.selection.displayText

  // create pagination bar
  const isFirstPage = props.currentPage === 0
  const isLastPage = props.currentPage === props.questions.length - 1
  let pageNav = null
  if (props.questions.length > 1) {
    pageNav = props.questions.map((_value, index) => index === props.currentPage ? (
      <span className='pageNavCenter' key={index}>
        <b className='centerCurrent'>{index + 1}</b>
      </span>
    ) : (
      <span className='pageNavCenter' key={index}>
        <span
          className='centerContent'
          onClick={() => props.onPageNav(index)}
        >
          {index + 1}
        </span>
      </span>
    ))

    pageNav.unshift(
      <span className='pageNavLeft' key='left'>
        {!isFirstPage ? (
          <span className='leftContent' onClick={props.onPageBackward}>
            {'<'}
          </span>
        ) : (
          <span className='arrowDisabled'>{'<'}</span>
        )}
      </span>
    )

    pageNav.push(
      <span className='pageNavRight' key='right'>
        {!isLastPage ? (
          <span className='rightContent' onClick={props.onPageForward}>
            {'>'}
          </span>
        ) : (
          <span className='arrowDisabled'>{'>'}</span>
        )}
      </span>
    )
  }
  return (
    <div className='assistant-content'>
      {_createNav(props.selections, props.onNav)}
      <div className='assistant-prompt'>
        <b>{`${props.content.static.questionsConfirmation}`}{' '}<CategoryText 
      selectedCategory={displayName}
      categories={props.content.categories}/>{`.`} </b>{' '}
        {props.content.static.questionsPrompt}
      </div>
      <div className='assistant-options'>
        {questions}
        {isLastPage ? (
          <span className='one-col'>
            <span
              className='assistant-option question-option none'
              data-tag='track-link'
              data-analytics-text={
                ANALYTICS_LINK_SECTIONS.ASSISTANT +
                props.content.static.noneHelpful
              }
              onClick={() => props.onClick({ deadend: true })}
            >
              {props.content.static.noneHelpful}
            </span>
          </span>
        ) : null}
      </div>
      <div className='pageNav'>{pageNav}</div>
    </div>
  )
}

function QuestionText (question) {
  /*(question.content
              ? question.content.displayText
              : question.displayText)*/
  var questionTxt = question.displayText;
      var qstntxt = question.displayText;
      const qstntxtarr  = qstntxt.split("||");
      if(qstntxtarr.length > 1){
        questionTxt = qstntxtarr[0];
      }
      return questionTxt;
}
function CategoryText (selectedCategory,categories) {
  /*(question.content
              ? question.content.displayText
              : question.displayText)*/
  var categoryTxt = String(selectedCategory.selectedCategory);


  let catkeys = Object.keys(selectedCategory.categories);

catkeys.forEach((i) => {
  if(String(i).toUpperCase() === categoryTxt.toUpperCase()){
           categoryTxt =  String(selectedCategory.categories[i]);
          }  

} );


  return categoryTxt;
}
function Answer (props) {
  let content
  switch (props.selection.content.contentType) {
    case 'TEXT':
      content = (
        <div>
          <div className='assistant-prompt'>
            <b>{props.content.static.question}</b>
          </div>
          <div className='assistant-prompt'>{props.selection.displayText}</div>
          <br />
          <div className='assistant-prompt'>
            <b>{props.content.static.answer}</b>
          </div>
          <div className='assistant-prompt'>
            {props.selection.content.displayText}
          </div>
        </div>
      )
      break
    case 'LINK':
      content = (
        <div className='assistant-prompt'>
          {props.content.static.linkBefore}
          <a
            href={props.selection.content.displayText}
            target='_blank'
            rel='noopener noreferrer'
          >
            {props.content.static.link}
          </a>
          {props.content.static.linkAfter}
        </div>
      )
      break
    case 'DOC': {
      if (!props.selections[2] ||
        !props.selection ||
        !props.selection.content
      ) {
        // each of these cases will fail with a null pointer exception, return before that happens
        return null
      }
      var documentNo = props.selection.content.displayText;
      var qstntxt = props.selection.displayText;
      const qstntxtarr  = qstntxt.split("||");
      if(qstntxtarr.length > 1){
        documentNo = qstntxtarr[1];
      }
      const doclink =
        `${API_BASE_URL}assistant/download?product=${props.selections[2].veevaProductCode}&documentNumber=${documentNo}&country=${StaticConfig.Context.Country.name}&searchUserType=${StaticConfig.Context.UserType}`
      content = (
        <div className='assistant-prompt'>
          <a
            href={doclink}
            target='_blank'
            rel='noopener noreferrer'
            data-tag='track-download'
            data-analytics-text={props.selection.content.displayText}
          >
            {props.content.static.docLink}
          </a>
        </div>
      )
      break
    }
    default:
      return <Error />
  }
  return (
    <div className='assistant-content'>
      {_createNav(props.selections, props.onNav)}
      {content}
    </div>
  )
}

/* ERROR PAGE */
function Error ({ content }) {
  return (
    <div className='error-container'>
      <div className='error-image'>
        <img src={via2} alt='Ami' />
      </div>

      <div className='assistant-prompt'>
        <b>{content.bold}</b> {content.message}
        <br /> <br />
        {content.suggestion}{' '}
        <Link data-tag='track-link' data-analytics-text='Search' to='/search'>{content.link}</Link>
        {content.end}
      </div>
    </div>
  )
}

/* NOT USEFUL PAGE */
function Deadend ({ content, permissions }) {
  // eslint-disable-next-line no-array-constructor
  const search = new Array()
  if (permissions.includes(PERMISSIONS.SEARCH)) {
    search.push(' ')
    search.push(content.link)
    search.push(' ')
    search.push(<Link data-tag='track-link' data-analytics-text='Search' to='/search'>{content.searchLink}</Link>)
  }
  return (
    <div className='error-container'>
      <div className='error-image'>
        <img src={via5} alt='Ami' />
      </div>

      <div className='assistant-prompt'>
        <b>{content.bold}</b> {content.disclaimer}
        <br />
        <br />
        {content.start}{' '}
        <Link data-tag='track-link' data-analytics-text='Submit Inquiry' to='/submit-inquiry'>{content.inquiryLink}</Link>
        { search }
        {content.confirmation}
      </div>
    </div>
  )
}

function _createNav (selections, handleNav) {
  
  let cookieCountryLanguage = getCookie('welcomeLanguage')
  let nav
  if (cookieCountryLanguage == 'fr')
  {
     nav = [
      <span
        key='Home'
        onClick={() => handleNav()}
        className='assistant-nav history'
      >
        {'Accueil'}
      </span>
  ]
  }
  else{
     nav = [
      <span
        key='Home'
        onClick={() => handleNav()}
        className='assistant-nav history'
      >
        {'Home'}
      </span>
  ]
  }

  selections.forEach((value, index, { length }) => {
    nav.push(' > ')
    const navClass =
      index === length - 1
        ? 'assistant-nav'
        : 'assistant-nav history'
    if (typeof value === 'object') {
      let displayText
      if (value.label) {
        displayText = value.label
      } else if (value.name) {
        displayText = value.name
      } else if (value.content) {
        if (cookieCountryLanguage === 'fr')
        {
          displayText = 'Répondre'
        }
        else{
          displayText = 'Answer'
        }
      } else {
        displayText = 'Question'
      }
      nav.push(
        <span key={index} onClick={() => handleNav(index)} className={navClass}>
          {displayText}
        </span>
      )
    } else {
      nav.push(
        <span key={index} onClick={() => handleNav(index)} className={navClass}>
          {value}
        </span>
      )
    }
  })
  return <div className='assistant-nav-container'>{nav}</div>
}

export default Content



// WEBPACK FOOTER //
// ./src/mi-app/digitalAssistant/Content.js